export default "__VITE_ASSET__Cm1Ajtcd__"